<template>
    <div style="">
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4" v-if="uid != ''">
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>イベント</b>
                            </div>
                        </div>
                        <div class="col-4 px-0 text-end" v-if="uid != ''">
                            <div style="display: inline-flex;">
                                <a class="text-center" href="/event/home" style="text-decoration:none;">
                                    <div class="text-center" style="color:#cdcdcd;padding-top:7px;">
                                        <svg style="height:25px;width:25px;fill:#cdcdcd;">
                                            <use xlink:href="/images/event_entry.svg#event_entry"></use>
                                        </svg>
                                        <div class="text-nowrap" style="font-size: 8px;">
                                            作成・管理
                                        </div>
                                    </div>
                                </a>
                                <div style="width:15px;"></div>
                                <a class="text-center" href="/info" style="text-decoration:none;">
                                    <div class="" style="color:#cdcdcd;padding-top:7px;">
                                        <svg style="height:25px;width:25px;fill:#cdcdcd;">
                                            <use xlink:href="/images/bell.svg#bell"></use>
                                        </svg>
                                        <div class="text-nowrap" style="font-size: 8px;">
                                            通知
                                        </div>
                                    </div>
                                </a>
                                <div style="color:red;position: absolute;right: 12px;" v-if="info_count != 0">●</div>
                                <div style="width:15px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height:50px;"></div>
        <div class="wrap">
            <div class="row" style="background-color:#F5F5F5">
                <div class="col">
                    <div class="row" v-if="event_member.length != 0">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="row">
                                    <div class="col">
                                        <br>
                                        <div style="font-size:14px;">
                                            <b>申込情報の確認</b>
                                        </div>
                                    </div>
                                </div>
                                <div v-for="event in event_member" :key="event.id">
                                    <div style="padding:5px 0;"
                                        v-if="event.is_event != 4 && !isEventEnd(event.event_at_to)">
                                        <a :href="'/event/member/' + event.eid" style="text-decoration:none;">
                                            <div style="background:#6B4EFF;padding:20px;border-radius:10px;">
                                                <div class="row d-flex align-items-center">
                                                    <div class="col" style="color:#fff;font-size:18px;">
                                                        <div v-if="event.is_event == 0">お支払いを完了させてください</div>
                                                        <div v-else-if="event.is_event == 1">予約済</div>
                                                        <div v-else-if="event.is_event == 2">当日決済（現金のみ）</div>
                                                    </div>
                                                    <div class="col-1 text-end">
                                                        <svg style="height:14px;width:9px;fill:#fff;">
                                                            <use xlink:href="/images/>.svg#page_right"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                        <a :href="'/event/details/' + event.eid" style="text-decoration:none;">
                                            <div style="background:#9990FF;padding:15px 20px;border-radius:10px;">
                                                <div class="row d-flex align-items-center">
                                                    <div class="col" style="color:#fff;">
                                                        <div>{{ event.thumbnail }}</div>
                                                        <div style="padding-top:5px;">
                                                            <div style="display:flex">
                                                                <div style="padding-right:5px">
                                                                    <i class="bi bi-clock"
                                                                        style="color:#fff;font-size:12px;position:relative;top:-4.5px;"></i>
                                                                </div>
                                                                <div>
                                                                    <div v-if="event.event_type == 1">
                                                                        <div class=""
                                                                            style="color:#fff;font-size:13px;">
                                                                            1部　{{
                            event.event_at_from_text_1
                        }}〜{{ event.event_at_to_text_1 }}</div>
                                                                        <div class=""
                                                                            style="color:#fff;font-size:13px;">
                                                                            2部　{{
                            event.event_at_from_text_2
                        }}〜{{ event.event_at_to_text_2 }}</div>
                                                                    </div>
                                                                    <div v-if="event.event_type == 2">
                                                                        <div class=""
                                                                            style="color:#fff;font-size:13px;">
                                                                            1部　{{
                            event.event_at_from_text_1
                        }}〜{{ event.event_at_to_text_1 }}</div>
                                                                        <div class=""
                                                                            style="color:#fff;font-size:13px;">
                                                                            2部　{{
                            event.event_at_from_text_2
                        }}〜{{ event.event_at_to_text_2 }}</div>
                                                                        <div class=""
                                                                            style="color:#fff;font-size:13px;">
                                                                            3部　{{
                            event.event_at_from_text_3
                        }}〜{{ event.event_at_to_text_3 }}</div>
                                                                    </div>
                                                                    <div v-else>
                                                                        <div class=""
                                                                            style="color:#fff;font-size:13px;">
                                                                            {{
                            event.event_at_from_text
                        }}〜{{ event.event_at_to_text }}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style="display:flex">
                                                                <div style="padding-right:5px">
                                                                    <i class="bi bi-geo-alt"
                                                                        style="color:#fff;font-size:12px;position:relative;top:-4.5px;"></i>
                                                                </div>
                                                                <div>
                                                                    <div class="" style="color:#fff;font-size:13px;">
                                                                        {{ event.address }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-1 text-end">
                                                        <svg style="height:14px;width:9px;fill:#fff;">
                                                            <use xlink:href="/images/>.svg#page_right"></use>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <br>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div style="margin:0 -12px;">
                                <img src="/images/luna_event_serach_1.webp" style="width:100%;height:auto">
                                <div style="margin-top: -230px;padding:0 12px;">
                                    <div class="row">
                                        <div class="col">
                                            <div style="padding:0 10px;">
                                                <input type="text" class="luna-form-control" id="search_box"
                                                    v-model="search_word" placeholder="イベントを検索" />
                                                <div style="height:10px"></div>
                                                <v-select name="area" :options="areas" v-model="area"
                                                    placeholder="地域を選択">
                                                </v-select>
                                            </div>
                                        </div>
                                    </div>
                                    <br>
                                    <div class="row justify-content-center">
                                        <div class="col-8">
                                            <div class="d-grid gap-2">
                                                <a type="button" class="btn btn-skip" @click="setSearch()"
                                                    style="padding:12px 0;border-radius: 50px;">
                                                    検索する
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="height:43px"></div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="row">
                                    <div class="col">
                                        <div style="font-size:14px;">
                                            <b>注目のイベント</b>
                                        </div>
                                    </div>
                                    <div class="col text-end">
                                        <a href="/event/pickup/list"
                                            style="font-size:14px;color:#777;text-decoration:none;">全てみる</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="table-responsive">
                                    <table class="table table-borderless p-0">
                                        <tbody class="p-0">
                                            <tr class="p-0">
                                                <td class="p-0">
                                                    <div class="row flex-nowrap" style="padding:0 10px;">
                                                        <div class="col-8 px-0"
                                                            style="max-width:350px;min-width:350px;margin:0 5px;"
                                                            v-for="event in event_pikup" :key="event.id">
                                                            <div style="padding:0 10px 30px 10px;">
                                                                <a :href="'/event/details/' + event.id"
                                                                    style="text-decoration:none;">
                                                                    <div class=""
                                                                        style="width: 100%;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 20px 0px;border-radius: 20px;overflow: hidden;;position: relative;">
                                                                        <div style="position: absolute;padding: 20px;">
                                                                            <div class="owner_label"
                                                                                v-if="event.owner_status == 1">
                                                                                <svg
                                                                                    style="height:18px;width:18px;fill:#fff;margin-top:-3px;">
                                                                                    <use
                                                                                        xlink:href="/images/label_event_luna.svg#label_event_luna">
                                                                                    </use>
                                                                                </svg>&nbsp;Luna主催
                                                                            </div>
                                                                            <div class="owner_label" v-else>
                                                                                ユーザー投稿
                                                                            </div>
                                                                        </div>
                                                                        <img :src="event.img_url" class="img-fluid">
                                                                        <div>
                                                                            <div class="text-center footer_event_after_box"
                                                                                v-if="isEventEnd(event.event_at_to)">
                                                                                開催終了
                                                                            </div>
                                                                            <div class="text-center footer_event_befor_box"
                                                                                v-else-if="event.is_preparation">
                                                                                <div class="row">
                                                                                    <div class="col text-start">
                                                                                        受付準備中
                                                                                    </div>
                                                                                    <div class="col text-end">
                                                                                        定員 {{ event.member_count }}人
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="text-center footer_event_now_box"
                                                                                v-else-if="event.is_recruiting">
                                                                                <div class="row">
                                                                                    <div class="col text-start">
                                                                                        &nbsp;&nbsp;参加者募集中
                                                                                    </div>
                                                                                    <div class="col text-end">
                                                                                        定員 {{ event.member_count
                                                                                        }}人&nbsp;&nbsp;
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="text-center footer_event_befor_box"
                                                                                v-else>
                                                                                申込上限に達しました
                                                                            </div>
                                                                        </div>
                                                                        <div style="padding-top:15px;padding-bottom:15px;"
                                                                            :class="setBackColor(event)">
                                                                            <div class="row">
                                                                                <div class="col-1"></div>
                                                                                <div class="col-3 text-center"
                                                                                    style="border-right: 1px solid #E6E6E6;">
                                                                                    <div style="font-size:20px;">
                                                                                        {{
                            setWeekDay(event.event_at_from)
                        }}
                                                                                    </div>
                                                                                    <div
                                                                                        style="font-size:13px;white-space: nowrap;">
                                                                                        {{
                                setDaysWithJp(event.event_at_from)
                            }}〜
                                                                                    </div>
                                                                                    <div v-if="event.event_type == 1"
                                                                                        style="font-size:13px;border:1px solid #C6C4FF;border-radius: 4px;">
                                                                                        2部制
                                                                                    </div>
                                                                                    <div v-else-if="event.event_type == 2"
                                                                                        style="font-size:13px;border:1px solid #C6C4FF;border-radius: 4px;">
                                                                                        3部制
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col">
                                                                                    <h5 style="color:#000">{{
                            event.thumbnail }}</h5>

                                                                                    <div style="display:flex">
                                                                                        <div style="padding-right:5px">
                                                                                            <i class="bi bi-clock"
                                                                                                style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                                                        </div>
                                                                                        <div>
                                                                                            <div
                                                                                                v-if="event.event_type == 1">
                                                                                                <div class=""
                                                                                                    style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                                                    1部　{{
                            setDaysWithSlash(event.event_at_from_1)
                        }}
                                                                                                    {{
                                setRmDate(event.event_at_from_text_1)
                            }}
                                                                                                </div>
                                                                                                <div class=""
                                                                                                    style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                                                    2部　{{
                                setDaysWithSlash(event.event_at_from_2)
                            }}
                                                                                                    {{
                                setRmDate(event.event_at_from_text_2)
                            }}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div
                                                                                                v-if="event.event_type == 2">
                                                                                                <div class=""
                                                                                                    style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                                                    1部　{{
                            setDaysWithSlash(event.event_at_from_1)
                        }}
                                                                                                    {{
                                setRmDate(event.event_at_from_text_1)
                            }}
                                                                                                </div>
                                                                                                <div class=""
                                                                                                    style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                                                    2部　{{
                                setDaysWithSlash(event.event_at_from_2)
                            }}
                                                                                                    {{
                                setRmDate(event.event_at_from_text_2)
                            }}
                                                                                                </div>
                                                                                                <div class=""
                                                                                                    style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                                                    3部　{{
                                setDaysWithSlash(event.event_at_from_3)
                            }}
                                                                                                    {{
                                setRmDate(event.event_at_from_text_3)
                            }}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div v-else>
                                                                                                <div class=""
                                                                                                    style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                                                    {{
                                setDaysWithSlash(event.event_at_from)
                            }}
                                                                                                    {{
                                setRmDate(event.event_at_from_text)
                            }}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div style="display:flex">
                                                                                        <div style="padding-right:5px">
                                                                                            <i class="bi bi-geo-alt"
                                                                                                style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                                                        </div>
                                                                                        <div>
                                                                                            <div class=""
                                                                                                style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                                                {{ event.address_view }}
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-1"></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div style="padding:0 10px;">
                                <div class="row">
                                    <div class="col">
                                        <div style="font-size:14px;">
                                            <b>全てのイベント</b>
                                        </div>
                                    </div>
                                    <div class="col text-end">
                                        <div style="font-size:14px;color:#777;margin-bottom:10px;">総合イベント数{{ event_count
                                            }}件
                                        </div>
                                        <div>
                                            <span
                                                :style="view_status == 1 ? 'color:#6b4eff;font-size:14px;' : 'font-size:14px;'"
                                                @click="view_status = 1, fetchEvents()">新着順</span>
                                            <span
                                                :style="view_status == 2 ? 'color:#6b4eff;margin-left:20px;font-size:14px;' : 'margin-left:20px;font-size:14px;'"
                                                @click="view_status = 2, fetchEvents()">開催日順</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div v-for="event in events" :key="event.id" data-testid="event-list-item">
                                <div style="padding:0 10px 30px 10px;">
                                    <a :href="'/event/details/' + event.id" style="text-decoration:none;">
                                        <div class=""
                                            style="width: 100%;box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 20px 0px;border-radius: 20px;overflow: hidden;">
                                            <div style="position: absolute;padding: 20px;">
                                                <div class="owner_label" v-if="event.owner_status == 1">
                                                    <svg style="height:18px;width:18px;fill:#fff;margin-top:-3px;">
                                                        <use xlink:href="/images/label_event_luna.svg#label_event_luna">
                                                        </use>
                                                    </svg>&nbsp;Luna主催
                                                </div>
                                                <div class="owner_label" v-else>
                                                    ユーザー投稿
                                                </div>
                                            </div>
                                            <img :src="event.img_url"
                                                style="width: 100%; height:auto;min-height:100px;">
                                            <div>
                                                <div class="text-center footer_event_after_box"
                                                    v-if="isEventEnd(event.event_at_to)">
                                                    開催終了
                                                </div>
                                                <div class="text-center footer_event_befor_box"
                                                    v-else-if="event.is_preparation">
                                                    <div class="row">
                                                        <div class="col-1"></div>
                                                        <div class="col text-start">
                                                            受付準備中
                                                        </div>
                                                        <div class="col text-end">
                                                            定員 {{ event.member_count }}人
                                                        </div>
                                                        <div class="col-1"></div>
                                                    </div>
                                                </div>
                                                <div class="text-center footer_event_now_box"
                                                    v-else-if="event.is_recruiting">
                                                    <div class="row">
                                                        <div class="col-1"></div>
                                                        <div class="col text-start">
                                                            参加者募集中
                                                        </div>
                                                        <div class="col text-end">
                                                            定員 {{ event.member_count }}人
                                                        </div>
                                                        <div class="col-1"></div>
                                                    </div>
                                                </div>
                                                <div class="text-center footer_event_befor_box" v-else>
                                                    申込上限に達しました
                                                </div>
                                            </div>
                                            <div style="padding-top:15px;padding-bottom:15px;"
                                                :class="setBackColor(event)">
                                                <div class="row">
                                                    <div class="col-1"></div>
                                                    <div class="col-3 text-center"
                                                        style="border-right: 1px solid #E6E6E6;">
                                                        <div style="font-size:20px;">
                                                            {{ setWeekDay(event.event_at_from) }}
                                                        </div>
                                                        <div style="font-size:13px;">
                                                            {{ setDaysWithJp(event.event_at_from) }}〜
                                                        </div>
                                                        <div v-if="event.event_type == 1"
                                                            style="font-size:13px;border:1px solid #C6C4FF;border-radius: 4px;">
                                                            2部制
                                                        </div>
                                                        <div v-else-if="event.event_type == 2"
                                                            style="font-size:13px;border:1px solid #C6C4FF;border-radius: 4px;">
                                                            3部制
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <h5 style="color:#000">{{ event.thumbnail }}</h5>

                                                        <div style="display:flex">
                                                            <div style="padding-right:5px">
                                                                <i class="bi bi-clock"
                                                                    style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                            </div>
                                                            <div>
                                                                <div v-if="event.event_type == 1">
                                                                    <div class=""
                                                                        style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                        1部　{{ setDaysWithSlash(event.event_at_from_1)
                                                                        }}{{
                            setRmDate(event.event_at_from_text_1) }}</div>
                                                                    <div class=""
                                                                        style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                        2部　{{ setDaysWithSlash(event.event_at_from_2)
                                                                        }}{{
                            setRmDate(event.event_at_from_text_2) }}</div>
                                                                </div>
                                                                <div v-if="event.event_type == 2">
                                                                    <div class=""
                                                                        style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                        1部　{{ setDaysWithSlash(event.event_at_from_1)
                                                                        }}{{
                            setRmDate(event.event_at_from_text_1) }}</div>
                                                                    <div class=""
                                                                        style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                        2部　{{ setDaysWithSlash(event.event_at_from_2)
                                                                        }}{{
                            setRmDate(event.event_at_from_text_2) }}</div>
                                                                    <div class=""
                                                                        style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                        3部　{{ setDaysWithSlash(event.event_at_from_3)
                                                                        }}{{
                            setRmDate(event.event_at_from_text_3) }}</div>
                                                                </div>
                                                                <div v-else>
                                                                    <div class=""
                                                                        style="color:#777;font-size:13px;padding-bottm:5px;">
                                                                        {{ setDaysWithSlash(event.event_at_from) }}{{
                            setRmDate(event.event_at_from_text) }}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style="display:flex">
                                                            <div style="padding-right:5px">
                                                                <i class="bi bi-geo-alt"
                                                                    style="color:#777;font-size:12px;position:relative;top:-1.5px;"></i>
                                                            </div>
                                                            <div>
                                                                <div class=""
                                                                    style="color:#777;font-size:14px;padding-bottm:5px;">
                                                                    {{ event.address_view }}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-1"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                    <div class="row">
                        <div class="col">
                            <div class="text-center" v-if="is_advertisements_footer">
                                <br>
                                <a :href="advertisements_footer[ad_footer_index].link_url" target="_blank"
                                    style="text-decoration:none;">
                                    <img :src="advertisements_footer[ad_footer_index].ad_image" class="img-fluid" />
                                </a>
                                <br>
                            </div>
                        </div>
                    </div>
                    <br>
                    <br>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div style="margin:0 -12px;">
                    <img src="/images/luna_event_serach_2.webp" style="width:100%;height:auto">
                    <div style="margin-top: -100px;padding:0 12px;">
                        <div class="row justify-content-center">
                            <div class="col-8">
                                <div class="d-grid gap-2">
                                    <a type="button" class="btn btn-skip" href="/event/entry/question1"
                                        style="padding:12px 0;border-radius: 50px;text-decoration:none;">
                                        新規イベント作成
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height:50px"></div>
                </div>
            </div>
        </div>
        <div style="margin:0 -12px;background:#6B4EFF;">
            <Footer></Footer>
            <br>
            <br>
            <br>
            <br>
        </div>
        <div v-if="uid != ''">
            <FooterMenu currentPage="event" />
        </div>
    </div>
</template>

<script>
import Footer from './../Footer.vue'
import FooterMenu from '../components/FooterMenu.vue';

export default {
    components: {
        Footer,
        FooterMenu
    },
    data() {
        return {
            view_status: 1,
            is_advertisements_footer: false,
            advertisements_footer: [],
            ad_footer_index: 0,
            events: [],
            event_member: [],
            event_count: 0,
            uid: "",
            info_count: 0,

            event_pikup: [],

            search_word: "",
            area: null,
            areas: [
                { value: "北海道", label: "北海道" },
                { value: "青森県", label: "青森県" },
                { value: "岩手県", label: "岩手県" },
                { value: "宮城県", label: "宮城県" },
                { value: "秋田県", label: "秋田県" },
                { value: "山形県", label: "山形県" },
                { value: "福島県", label: "福島県" },
                { value: "茨城県", label: "茨城県" },
                { value: "栃木県", label: "栃木県" },
                { value: "群馬県", label: "群馬県" },
                { value: "埼玉県", label: "埼玉県" },
                { value: "千葉県", label: "千葉県" },
                { value: "東京都", label: "東京都" },
                { value: "神奈川県", label: "神奈川県" },
                { value: "新潟県", label: "新潟県" },
                { value: "富山県", label: "富山県" },
                { value: "石川県", label: "石川県" },
                { value: "福井県", label: "福井県" },
                { value: "山梨県", label: "山梨県" },
                { value: "長野県", label: "長野県" },
                { value: "岐阜県", label: "岐阜県" },
                { value: "静岡県", label: "静岡県" },
                { value: "愛知県", label: "愛知県" },
                { value: "三重県", label: "三重県" },
                { value: "滋賀県", label: "滋賀県" },
                { value: "京都府", label: "京都府" },
                { value: "大阪府", label: "大阪府" },
                { value: "兵庫県", label: "兵庫県" },
                { value: "奈良県", label: "奈良県" },
                { value: "和歌山県", label: "和歌山県" },
                { value: "鳥取県", label: "鳥取県" },
                { value: "島根県", label: "島根県" },
                { value: "岡山県", label: "岡山県" },
                { value: "広島県", label: "広島県" },
                { value: "山口県", label: "山口県" },
                { value: "徳島県", label: "徳島県" },
                { value: "香川県", label: "香川県" },
                { value: "愛媛県", label: "愛媛県" },
                { value: "高知県", label: "高知県" },
                { value: "福岡県", label: "福岡県" },
                { value: "佐賀県", label: "佐賀県" },
                { value: "長崎県", label: "長崎県" },
                { value: "熊本県", label: "熊本県" },
                { value: "大分県", label: "大分県" },
                { value: "宮崎県", label: "宮崎県" },
                { value: "鹿児島県", label: "鹿児島県" },
                { value: "沖縄県", label: "沖縄県" },
                { value: "オンライン", label: "オンライン" },
            ],
        };
    },
    methods: {
        async init() {
            await axios.get("/api/auth/user/get")
                .then(
                    (response) => {
                        this.uid = response.data.uid

                        //this.getAdvertisements()
                        this.fetchEvents()
                        this.fetchPickupEvents()
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        this.fetchEvents()

                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async getUnreadCount() {
            await axios.get("/api/information/count/get")
                .then(
                    (response) => {
                        this.info_count = response.data.count
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("通知の取得に失敗しました")
                    }
                })
        },
        async getAdvertisements() {
            axios.get("/api/advertisement/get/4")
                .then((response) => {
                    this.advertisements_footer = response.data.advertisements
                    this.is_advertisements_footer = this.advertisements_footer.length > 0
                })
        },
        async fetchEvents() {
            await axios.get("/api/event/list" + '?type=' + this.view_status)
                .then((response) => {
                    // 想定外のレスポンス（キー欠落等）でも v-for / .length が壊れないようにする
                    this.events = Array.isArray(response.data.events) ? response.data.events : [];
                    this.event_member = Array.isArray(response.data.event_member) ? response.data.event_member : [];
                    this.event_count = response.data.event_count ?? 0;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                })
        },
        async fetchPickupEvents() {
            await axios.get("/api/event/pickup")
                .then((response) => {
                    this.event_pikup = response.data.events;
                })
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        //window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの取得に失敗しました")
                    }
                })
        },
        apply() {

        },
        isEventEnd(event) {
            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            return (eDate < today);
        },
        setWeekDay(event) {
            let event_date = event.split(' ')[0]
            let eDate = new Date(event_date.split('-')[0], event_date.split('-')[1] - 1, event_date.split('-')[2])
            let dayOfWeek = eDate.getDay()
            let dayOfWeekStr = ["日", "月", "火", "水", "木", "金", "土"][dayOfWeek]

            return dayOfWeekStr
        },
        setDaysWithJp(event) {
            let event_date = event.split(' ')[0]
            return Number(event_date.split('-')[1]) + '月' + Number(event_date.split('-')[2]) + '日'
        },
        setDaysWithSlash(event) {
            let event_date = event.split(' ')[0]
            return Number(event_date.split('-')[1]) + '/' + Number(event_date.split('-')[2])
        },
        setRmDate(event) {
            return event.substr(10) + '〜';
        },
        setBackColor(event) {
            let c = "";

            if (this.isEventEnd(event.event_at_to)) {
                c = "end_back"
            }
            else if (event.is_preparation) {
                c = "preparation_back"
            }
            else if (event.is_recruiting) {
                c = "recruiting_back"
            }
            else {
                c = "up_back"
            }

            return c
        },
        setSearch() {
            let search_area = ""

            if (this.area != null) {
                search_area = this.area.value
            }

            window.location.href = "/event/search?w=" + this.search_word + '&a=' + search_area
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.init()
                            this.getUnreadCount()
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.init()
                this.getUnreadCount()
            }
        }
        else {
            this.init()
            this.getUnreadCount()
        }
    }
}
</script>
<style scoped>
.end_back {
    background-color: #E6E6E6;
}

.preparation_back {
    background-color: #E7E7FF;
}

.recruiting_back {
    background-color: #fff;
}

.up_back {
    background-color: #E7E7FF;
}

.footer_event_after_box {
    background-color: #cdcdcd;
    color: #999;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_befor_box {
    background-color: #C6C4FF;
    color: #6B4EFF;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_now_box {
    background-color: #6B4EFF;
    color: #fff;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}

.owner_label {
    color: #fff;
    background-color: #6b4eff;
    padding: 5px 20px 5px 15px;
    border-radius: 20px;
}

#search_box::placeholder {
    color: #cdcfd0;
}
</style>
